import { Navigate } from 'react-router-dom';
import React from 'react';
import { useAuthStore } from '../zustand-store/auth.store';
import PropTypes from 'prop-types';

export const PrivateRoute = ({ children, roles }) => {
  const role = useAuthStore((state) => state.role);
  const accessToken = useAuthStore((state) => state.accessToken);
  const detailsProvided = useAuthStore((state) => state.detailsProvided);
  const isInitializing = useAuthStore((state) => state.isInitializing);

  if (isInitializing) {
    return null;
  }

  const userHasRequiredRole = roles.includes(role);
  if (!accessToken) {
    return <Navigate to={'/login'} />;
  }
  // alert(detailsProvided)
// alert(detailsProvided)
//   if (accessToken && detailsProvided === false) {
//     return <Navigate to={'/business-details'} />;
//   }

  if (!userHasRequiredRole) {
    return 'Not Found';
  }

  return children;
};

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
  roles: PropTypes.arrayOf(PropTypes.string).isRequired
};
